import { GetUsernameSuggestionType, UserType } from "../../types/User";
import { post } from "../../utils/axios-config";
import { USERS, USERS_GET_USERNAME_SUGGESTION } from "../../utils/constants";

export const createUser = async (data: UserType) => await post<UserType, string>(USERS, data);

export const getUserNameSuggestion = async (data: GetUsernameSuggestionType) => await post<GetUsernameSuggestionType, string>(USERS_GET_USERNAME_SUGGESTION, data);